import { Component, Input, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { AccountingAccountsModel } from './accounting-accounts.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Utils } from '../../../shared/utils';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-accountingAccounts-form',
    templateUrl: './accounting-accounts-form.component.html',
    styleUrls: ['./accounting-accounts.component.css'],
    standalone: false
})

export class AccountingAccountsFormComponent implements OnInit {

  @Input() accountingAccounts: AccountingAccountsModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  public numberLengthError: boolean = false;
  public nameLengthError: boolean = false;

  public accountingAccountsTypeOptions: Option[] = [
    { label: 'Impuestos', value: 'impuestos' },
    { label: 'Ingreso', value: 'ingreso' },
    { label: 'Gasto', value: 'gasto' },
    { label: 'Existencias', value: 'existencias' },
    { label: 'Financiación', value: 'financiacion' },
    { label: 'Tesorería', value: 'tesoreria' },
    { label: 'Socios', value: 'socios' },
    { label: 'Anticipos a proveedores', value: 'anticipos_a_proveedores' },
    { label: 'Anticipos a clientes', value: 'anticipos_de_clientes' },
    { label: 'Clientes', value: 'clientes' },
    { label: 'Deuda', value: 'deuda' },
    { label: 'Deudores', value: 'deudores' },
    { label: 'Dividendos', value: 'dividendos' },
    { label: 'Inversión', value: 'inversion' },
    { label: 'Personal / Empleados', value: 'personal_empleados' },
    { label: 'Proveedores / Acreedores', value: 'proveedores_acreedores' },
  ];

  constructor(public snackBar: MatSnackBar) { }

  ready = false;

  public ngOnInit() {
    this.ready = true;
  }

  public save(accountingAccounts: AccountingAccountsModel): void {

    if (Utils.IsNullOrEmpty(accountingAccounts.type)) {
      return;
    }

    if (Utils.IsNullOrEmpty(accountingAccounts.number)) {
      return;
    }

    if (Utils.IsNullOrEmpty(accountingAccounts.name)) {
      return;
    }


    if (accountingAccounts.number.length != 10) {
      this.numberLengthError = true;
    } else {
      this.numberLengthError = false;
    }

    if (accountingAccounts.name.length > 125) {
      this.nameLengthError = true;
    } else {
      this.nameLengthError = false;
    }

    if (this.numberLengthError === false && this.nameLengthError === false) {

      if (this.isValidAccountNumber(accountingAccounts.number) === true) {
        this.onSave.emit(accountingAccounts);
      }
      else {
        this.displayInfo('El número de cuenta contable no tiene un formato correcto.');
      }

    }

  }

  private isValidAccountNumber(accountNumber: string): boolean {
    const regex = new RegExp(/^[1-9]{1}[0-9]{9}$/gm);

    return regex.test(accountNumber);
  }

  public keyDownTabPress(event: any): void {

    const eventNumber: string = event.target.value;

    if (eventNumber.includes('.') === true) {

      const splitedNumber: string[] = eventNumber.split('.');

      // Result from 600.1 must be...
      // [0] -> 600 - [1] -> 1

      const firstPartLength: number = splitedNumber[0].length; // 3

      const secondPartLength: number = splitedNumber[1].length; // 1

      const maxLength: number = 10; // 10

      const totalLength: number = firstPartLength + secondPartLength; // 4

      const operationResult: number = maxLength - totalLength; // 6

      let zerosToComplete: string = '';

      for (let i = 0; i < operationResult; i++) {
        zerosToComplete += '0';
      }

      const numberCreation: string[] = [];

      numberCreation[0] = splitedNumber[0];

      numberCreation[1] = zerosToComplete;

      numberCreation[2] = splitedNumber[1];

      const result: string = numberCreation.join('');

      if (result.length === 10) {
        this.accountingAccounts.number = result;
      }

    }

  }

  changeToggle(element) {
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
